/* arissai-exit-intent.js v27 — recover abandoning visitors with the 10% code */
(function(){
  "use strict";
  var KEY = "arissai_exit_intent_v1";
  var DISCOUNT_CODE = "ARISSAI10";
  if (sessionStorage.getItem(KEY) === "shown") return;
  if (localStorage.getItem(KEY) === "dismissed") return;

  var triggered = false, idleTimer = null;

  function buildModal(){
    var wrap = document.createElement("div");
    wrap.className = "arissai-exit"; wrap.setAttribute("data-testid","exit-intent-modal");
    wrap.innerHTML =
      '<div class="arissai-exit__bg"></div>'+
      '<div class="arissai-exit__card" role="dialog" aria-label="Special offer">'+
        '<button class="arissai-exit__x" aria-label="Close" data-testid="exit-close">&times;</button>'+
        '<p class="arissai-exit__eyebrow">Before you go</p>'+
        '<h2 class="arissai-exit__h">Save 10% on your first Arissai piece</h2>'+
        '<p class="arissai-exit__p">Made on demand in Toronto. Free shipping to USA &amp; Canada. Your code:</p>'+
        '<div class="arissai-exit__code" data-testid="exit-code">'+ DISCOUNT_CODE +'</div>'+
        '<button class="arissai-exit__cta" data-testid="exit-shop">Shop the Collection</button>'+
        '<p class="arissai-exit__fine">One use per customer · Auto-applies at checkout · 30-day returns</p>'+
      '</div>';
    document.body.appendChild(wrap);
    setTimeout(function(){ wrap.classList.add("is-open"); }, 30);

    function close(){
      wrap.classList.remove("is-open");
      setTimeout(function(){ wrap.remove(); }, 280);
      sessionStorage.setItem(KEY, "shown");
    }
    function dismissForever(){ localStorage.setItem(KEY, "dismissed"); close(); }

    wrap.querySelector(".arissai-exit__x").addEventListener("click", dismissForever);
    wrap.querySelector(".arissai-exit__bg").addEventListener("click", close);
    wrap.querySelector(".arissai-exit__cta").addEventListener("click", function(){
      // Auto-copy code to clipboard
      try { navigator.clipboard.writeText(DISCOUNT_CODE); } catch(e){}
      close();
      location.assign("/collections/all?discount=" + DISCOUNT_CODE);
    });
    wrap.querySelector(".arissai-exit__code").addEventListener("click", function(){
      try { navigator.clipboard.writeText(DISCOUNT_CODE); this.textContent = "Copied!"; var self=this; setTimeout(function(){ self.textContent = DISCOUNT_CODE; }, 1500); } catch(e){}
    });
  }

  function maybeShow(){
    if (triggered) return;
    triggered = true;
    if ("requestIdleCallback" in window) requestIdleCallback(buildModal, { timeout: 400 });
    else setTimeout(buildModal, 50);
  }

  // Desktop: exit-intent (mouse leaves viewport upward)
  if (!("ontouchstart" in window) && window.innerWidth > 749) {
    document.addEventListener("mouseleave", function(e){
      if (e.clientY < 20 && !triggered) maybeShow();
    });
  }
  // Mobile: time-based (45s idle) or scroll-to-bottom trigger
  else {
    setTimeout(maybeShow, 45000);
    window.addEventListener("scroll", function(){
      var sb = window.scrollY + window.innerHeight;
      if (sb > document.body.scrollHeight * 0.85) maybeShow();
    }, { passive: true });
  }
  // Universal: trigger after 90s of no interaction
  function resetIdle(){ if (idleTimer) clearTimeout(idleTimer); idleTimer = setTimeout(maybeShow, 90000); }
  ["mousemove","scroll","touchstart","keypress","click"].forEach(function(ev){
    document.addEventListener(ev, resetIdle, { passive: true });
  });
  resetIdle();
})();
